import { css } from '@emotion/react'
import { Cell, Grid, HeadingSection, InfoLabel } from 'bold-ui'
import { RastreioCancerPerguntaDbEnum } from 'graphql/types.generated'

import { CitopatologicoGrupoDadosColeta } from './CitopatologicoGrupoDadosColeta'
import { CitopatologicoVisualizacaoProps } from './CitopatologicoVisualizacao'
import { CITOPATOLOGICO_PERGUNTAS_DADOS_COLETA } from './model-citopatologico'

export function CitopatologicoDadosColetaSection(props: Readonly<CitopatologicoVisualizacaoProps>) {
  const { questoesRespondidas } = props
  const has = (key: RastreioCancerPerguntaDbEnum) => questoesRespondidas.has(key)
  const get = (key: RastreioCancerPerguntaDbEnum) => questoesRespondidas.get(key)
  const label = (key: RastreioCancerPerguntaDbEnum) => CITOPATOLOGICO_PERGUNTAS_DADOS_COLETA[key]

  const temAlgum = Object.keys(CITOPATOLOGICO_PERGUNTAS_DADOS_COLETA).some((key) =>
    questoesRespondidas.has(key as RastreioCancerPerguntaDbEnum)
  )
  if (!temAlgum) return null

  const { grid } = createStyles()

  return (
    <>
      <HeadingSection level={4} vSpace={2} title='DADOS DA COLETA' />
      <Grid style={grid}>
        {has(RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_03_01) && (
          <Cell size={12}>
            <InfoLabel title={label(RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_03_01)!}>
              {get(RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_03_01)}
            </InfoLabel>
          </Cell>
        )}
        <CitopatologicoGrupoDadosColeta
          titulo='Responsável pela coleta'
          itens={[RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_03_02, RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_03_03]}
          has={has}
          get={get}
          label={label}
        />
        <CitopatologicoGrupoDadosColeta
          titulo='Conselho'
          itens={[RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_03_05, RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_03_04]}
          has={has}
          get={get}
          label={label}
        />
      </Grid>
    </>
  )
}

const createStyles = () => ({
  grid: css`
    width: 100%;
  `,
})
